import Vue from "vue";
import Container from "@/components/custom/Container.vue";
import Button from "@/components/custom/Button.vue";
import TextField from "@/components/custom/TextField.vue";

Vue.component("Container", Container);
Vue.component("Button", Button);
Vue.component("TextField", TextField);
